// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"d07726c727482617","5285":"b326ea88ed8d41e8"}[chunkId] + ".css";
};